module.exports = __webpack_public_path__ + "soir.25cd47cf549af0c9ee147f3dcc297258.png";